import { ArrowLeftIcon } from '../../icons/arrowLeft';
import { ArrowRightIcon } from '../../icons/arrowRight';
import { PaginationItemType } from './model';

export const pageTypeToIcon: Partial<Record<PaginationItemType, React.FC>> = {
  previous: ArrowLeftIcon,
  next: ArrowRightIcon,
};
